module.exports = __webpack_public_path__ + "static/img/10006 (2).5a8f5e7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10006 (2).webp
// module id = R5ak
// module chunks = 14